import React from 'react';
import {
  AiOutlineHome,
  AiFillHome,
  AiOutlineSetting,
  AiTwotoneSetting,
  AiFillGithub,
  AiOutlineQuestionCircle,
  AiOutlineBarChart,
} from 'react-icons/ai';
import { RiContactsFill, RiContactsLine } from 'react-icons/ri';
import { BiPhotoAlbum } from 'react-icons/bi';
import {
  SiFacebook,
  SiMathworks,
  SiAdobephotoshop,
  SiReact,
} from 'react-icons/si';
import {
  IoLanguageOutline,
  IoInvertModeOutline,
  IoServer,
} from 'react-icons/io5';
import { IoMdPhotos, IoLogoJavascript, IoLogoPython } from 'react-icons/io';
import {
  BsCode,
  BsCodeSlash,
  BsLayers,
  BsFillLayersFill,
} from 'react-icons/bs';
import { MdLayers } from 'react-icons/md';
import { ImTree } from 'react-icons/im';
import { GiBrain, GiCyberEye } from 'react-icons/gi';
import { HiOutlinePresentationChartLine } from 'react-icons/hi';
import { US, VN } from 'country-flag-icons/react/3x2';

export const en = {
  translation: {
    leftDrawer: {
      navigations: [
        {
          path: '/',
          name: 'Home',
          icon: <AiOutlineHome />,
          activeIcon: <AiFillHome />,
        },
        {
          path: '/graphics',
          name: 'Graphics',
          icon: <BiPhotoAlbum />,
          activeIcon: <IoMdPhotos />,
        },
        {
          path: '/science',
          name: 'Science',
          icon: <BsLayers />,
          activeIcon: <BsFillLayersFill />,
        },
        {
          path: '/programing',
          name: 'Programing',
          icon: <BsCode />,
          activeIcon: <BsCodeSlash />,
        },
        {
          path: '/about',
          name: 'About',
          icon: <RiContactsLine />,
          activeIcon: <RiContactsFill />,
        },
        {
          path: '/settings',
          name: 'Settings',
          icon: <AiOutlineSetting />,
          activeIcon: <AiTwotoneSetting />,
        },
      ],

      footer: {
        contacts: [
          {
            name: 'github',
            href: 'https://github.com/mthang1801',
            icon: <AiFillGithub />,
          },
          {
            name: 'facebook',
            href: 'https://www.facebook.com/mvt.dev',
            icon: <SiFacebook />,
          },
        ],
        text: `Copyright @${new Date().getFullYear()} All rights reserved | This template is made by MVT`,
      },
    },
    first_sub_navigation_icons: {
      javascript: <IoLogoJavascript />,
      python: <IoLogoPython />,
      mathematics: <SiMathworks />,
      photoshop: <SiAdobephotoshop />,
    },
    second_sub_navigation_icons: {
      'back-end-development': <IoServer />,
      basics: <MdLayers />,
      'data-structures-and-algorithms': <ImTree />,
      'deep-learning': <GiBrain />,
      'front-end-development': <SiReact />,
      'machine-learning': <HiOutlinePresentationChartLine />,
      opencv: <GiCyberEye />,
      'questions-interview': <AiOutlineQuestionCircle />,
      'statistics-and-probability': <AiOutlineBarChart />,
    },
    alert: {
      noPost: 'Have not found any posts.',
    },
    sidebar: {
      navigations: 'Navigations',
      menuNavs: {
        programing: 'Programing',
        graphics: 'Graphics',
        science: 'Science',
        javascript: 'Javascript',
        python: 'Python',
        mathematics: 'Mathematícs',
        photoshop: 'Photoshop',
        'back-end-development': 'Back-end',
        basics: 'Basics',
        'data-structures-and-algorithms': 'Data structures and algorithms',
        'front-end-development': 'Front-end development',
        'machine-learning': 'Machine Learning',
        'questions-interview': 'Questions interview',
        'statistics-and-probability': 'Statistics and probability',
        opencv: 'OpenCV',
        'deep-learning': 'Deep learning',
      },
      newsLetter: {
        title: 'Mail Box',
        subtitle: 'Let your feedback here, thank you!',
        namePlaceholder: 'Your Name',
        emailPlaceholder: 'Your Email',
        feedbackPlaceholder: 'Feedback content',
        submitButton: 'Send',
      },
      popularArticles: 'Popular Articles',
      tags: 'Tags',
      history: 'History',
      paragraph: 'Paragraph',
      readMore: 'Read More',
      readLess: 'Shorten',
      tableOfContent: 'Table Of Content',
    },
    datetime: {
      months: {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      },
    },
    posts: {
      postCard: {
        title: 'Recommended Posts',
      },
      relevantPosts: 'Relevant Posts',
      postViewsUndefined: 'Undetermined',
    },
    search: {
      placeholder: 'Search',
      emptyResult: (searchKey) =>
        `Not found any results for <strong>${searchKey}</strong>`,
    },
    history: {
      title: 'History of Posts',
    },
    settings: {
      title: 'Settings',
      close: 'Close',
      languages: {
        back: 'Settings',
        icon: <IoLanguageOutline />,
        label: 'Language',
        subLabel: 'Choose language you want.',
        values: [
          { key: 'en', text: 'English', code: 'US', icon: <US /> },
          { key: 'vi', text: 'Tiếng Việt', code: 'VN', icon: <VN /> },
        ],
      },
      themes: {
        back: 'Settings',
        icon: <IoInvertModeOutline />,
        label: 'Theme Mode',
        subLabel: 'Choose theme mode you want.',
        values: [
          {
            key: 'light',
            text: 'Light',
            background: '#fff',
          },
          {
            key: 'dark',
            text: 'Dark',
            background: '#2c2c2c',
          },
        ],
      },
    },
    seo: {
      home: 'Home',
      about: 'About',
      pageError: 'Page Error',
      category: {
        programing: 'Programing',
        graphics: 'Graphics',
        science: 'Science',
      },
      firstChildCategory: {
        javascript: 'Javascript',
        mathematics: 'Mathematics',
        photoshop: 'Photoshop',
        python: 'Python',
      },
      secondChildCategory: {
        'back-end-development': 'Back-end',
        basics: 'Basics',
        'data-structures-and-algorithms': 'Data structures and algorithms',
        'front-end-development': 'Front-end development',
        'machine-learning': 'Machine Learning',
        'questions-interview': 'Questions interview',
        'statistics-and-probability': 'Statistics and probability',
        opencv: 'OpenCV',
        'deep-learning': 'Deep learning',
      },
    },
    about: {
      title: 'About me',
      updatingStatus:
        'This page is maintaining or updating, we will come back soon.',
    },
    tags: {
      title: 'List of tags',
      specificTagTitle: (tagName) => `Search restults for tag ${tagName}`,
    },
    page: {
      pageError:
        'The page you are looking for might have been removed, had its name changed or temporarily unvailable.',
    },
  },
};
